<template>
	<div class="pageBox">
		<Header current='souye' ref="Header"></Header>
		<div class="pageBox_cen">
			<template v-for="(item, index) in showList">
				<component :is="mapComponent[item.name]" :dataInfo="item.data" paddingTop="86px"
					:background="item.background" :list='item' :ref="item.name" />
			</template>
		</div>
		<Footer></Footer>
	</div>
</template>

<script>
import Header from "@/components/header.vue"
import Footer from "@/components/footer.vue"
import indexTitle from "@/components/c/indexTitle.vue"
import mapComponent from "@/components/mapComponent.js";
import {
	get_banner,
	getHomeInfo,
	get_home_product,
	get_news,
	get_core_tec
} from "@/api/index.js"
export default {
	components: {
		Header,
		Footer,
		indexTitle,
	},
	data() {
		return {
			mapComponent,
			list: [
				// {
				// 	name: 'indexBanner',
				// 	value: '首页轮播图',
				// 	data: {},
				// },
				{
					name: 'newIndexBanner',
					value: '首页轮播图',
					data: {},
					show: 1,
				},
				{
					name: 'featuredProducts',
					value: '精选产品',
					data: {},
					show: 0,
				},
				{
					name: 'endoscopy',
					value: '内镜',
					data: {},
					show: 0,
				},
				{
					name: 'indexHexin',
					value: '产品洞察',
					data: {},
					show: 0,
				},
				{
					name: 'clinicalCases',
					value: '临床病例',
					data: {},
					show: 0,
				},
				{
					name: 'Partners',
					value: '合作伙伴',
					background: '#F7F7F7',
					data: {},
					show: 0,
				}, {
					name: 'missionIndex',
					value: '任务',
					data: {},
					show: 0,
				}],
		}
	},
	computed: {
		showList() {
			return this.list.filter(el => el.show == 1)
		}
	},
	mounted() {
		let t = this;
		// 获取首页轮播图
		t.getBannerList(1);

		t.getHomeData()

		window.addEventListener('scroll', this.handleScroll);
		this.currentRoute = this.$route.path; // 初始化时获取当前路由地址
		this.$watch('$route', this.onRouteChange);
		var element;
		if (this.nowVibe == 'pc') {
			element = document.documentElement
		} else {
			element = document.documentElement.scrollTop ? document.documentElement : document.body;
		}
		let scrollTop = element.scrollTop;
		if (scrollTop == 0) {
			this.$refs.Header.headerHover = false;
			this.$refs.Header.headerTrue = false;
		} else {
			this.$refs.Header.headerTrue = true;
			this.$refs.Header.headerHover = true;
		}
	},
	beforeDestroy() {
		window.removeEventListener('scroll', this.handleScroll);

	},
	methods: {
		handleScroll() {
			const currentScrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body
				.scrollTop || 0;
			if (currentScrollTop > this.lastScrollTop) {
				this.navHidden = true;
			} else {
				this.navHidden = false;
			}
			this.lastScrollTop = currentScrollTop;

			if (currentScrollTop == 0) {
				if (!this.$refs.Header.navHead) {
					this.$refs.Header.headerHover = false;
				}
				this.$refs.Header.headerTrue = false;
			} else {
				this.$refs.Header.headerTrue = true;
				this.$refs.Header.headerHover = true;
			}
		},
		// 获取首页轮播图
		getBannerList(e) {
			let t = this;
			let data = {
				type: e
			}
			get_banner(data).then((res) => {
				this.list[0].show = 1
				this.$nextTick(function () {
					t.$refs['newIndexBanner'][0].setList(res.data);
				})
			}).catch((err) => {
				console.log(err)
			})
		},
		//获取首页数据
		getHomeData() {
			getHomeInfo({}).then(res => {
				let listData = res.data
				listData.forEach((el, index) => {
					this.list[index + 1].data = el
					this.list[index + 1].show = el.is_show
					this.list[index + 1].sort = el.sort
				})
				if (res.data[2].is_show == 1) {
					let list = res.data[2].list
					list = list.map(el => {
						return {
							id: el.id,
							jump_url: el.jump_url,
							type: 1,
							other: {
								bigTitle: [{ title: el.title }],
								smallTitle: [{ title: el.desc }]
							},
							url: el.cover,
							video_cover: el.video_cover,
						}
					})
					this.$nextTick(() => {
						this.$refs['indexHexin'][0].setList(list);
					})
				}
			})
		},
	}
}
</script>

<style></style>
<style scoped lang="scss">
.pageBox {
	display: flex;
	flex-direction: column;
	min-height: 100vh;

	.pageBox_cen {
		flex: 1;
	}
}
</style>